export default {
  content: ''+
  '<div class="text-box">'+
  // '<h3 class="h3-line">(一)竞赛飞行时间：＞10分钟</h3>'+
  '<h3 class="h3-line">竞赛飞行流程</h3>'+
  '<p class="text-line">1.竞赛双方各有3名队员。开赛前，双方参赛选手将飞行器放置在指定位置，并将遥控器放于面前地面上。同时场地内可额外放置一台备用飞行器，并将其对应遥控器放置在活动区域的地面上。如果竞赛中出现飞行器坠机于地面且无法复飞的情况，选手可以选择改用备用飞行器继续竞赛。竞赛场地中间有一个高约70cm，直径约40cm的“本垒”。双方队员通过控制飞行器降落到本垒并停留足够时间来获得分数，从而赢得竞赛。</p>'+
  '<p class="text-line">2.竞赛分为上下半场各3分钟，中场休息2分钟，可以在中场休息时更换参赛飞行器，竞赛开始后不设立暂停，直到半场结束。</p>'+
  '<p class="text-line">3.竞赛中，当某一队的飞机落在本垒上且停桨上锁，则裁判开始计时，每过10秒得1分，直到被对方从本垒上撞落或者自行解锁为止。未满10秒不得分。</p>'+
  '<p class="text-line">4.同一时间有多台飞行器叠在本垒上，只有最下面的飞行器能够得分。</p>'+
  '<p class="text-line">5.竞赛结束时，获得分数高者获胜，分数相同即为平局。淘汰赛中如遇平局，将采用“金球制胜法”确认晋级队伍。</p>'+
  '<p class="text-line">6.赛允许在场地内采用撞击，压顶，托举，气流干扰，阻挡等各种战术。</p>'+
  '<img class="img-line" src="/work/static/img/uva/XKG/t35.jpg" width="100%" />' +
  '<img class="img-line" src="/work/static/img/uva/XKG/t36.jpg" width="100%" />' +
  '</div>'
}